import { useInjection } from 'libs/uikit/ioc/React';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Location, Navigate, Outlet, createSearchParams, useLocation } from 'react-router-dom';
import { IAuthenticationStore } from './Abstractions/IAuthenticationStore';

export const AuthenticationRouteGuard = observer(() => {
  const authenticationStore = useInjection(IAuthenticationStore);

  const authenticated = authenticationStore.isAuthenticated();

  const location = useLocation();

  if (!authenticated) {
    return <Navigate to={`/account/login?${createReturnUrl(location)}`} replace={true} />;
  }

  return <Outlet />;
});

function createReturnUrl(location: Location): string {
  return createSearchParams({
    returnUrl: `${location.pathname}${location.search}${location.hash}`,
  }).toString();
}
